import { watch } from "vue"

/**
 * Applies a watch to the user details to ensure the progression email matches if one isn't set
 * 
 * @param {Object} progression 
 * @param {Object} form 
 */
export function createFormFieldUserEmailWatch(progression, form){
    watch(() => form.fields.value.user.email, (email, oldEmail) => {
        if(progression.details.value.email === oldEmail || progression.details.value.email == null){
            progression.details.value.email = email
        }

        if(form.fields.value.contact.email === oldEmail || form.fields.value.contact.email == null){
            form.fields.value.contact.email = email

            if(form.fields.value.contact.email_confirmation === oldEmail || form.fields.value.contact.email_confirmation == null){
                form.fields.value.contact.email_confirmation = email
            }
        }
    })
}